export default "__VITE_ASSET__EKotAV_Y__"